import { Reveal } from "@/lib/reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/context/LanguageContext";

export const FAQ = () => {
  const { t } = useLanguage();
  const faqList = t.faq.items || [];

  return (
    <section id="faq" data-testid="faq" className="py-24 md:py-32 bg-card border-y border-border">
      <div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal className="overline font-bold tracking-[0.2em]">{t.faq.overline}</Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
                {t.faq.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base sm:text-lg text-foreground/80 font-medium leading-relaxed max-w-sm">
                {t.faq.desc}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqList.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-border">
                <AccordionTrigger className="text-left text-lg md:text-xl font-bold tracking-tight text-foreground hover:no-underline py-6 hover:text-accent">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-foreground/80 font-medium leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
